/* PagingImagesFeed.js */

const PagingFeed = require("../../../../../../../lib/PagingFeed");
const query = { status: { $nin: ["DRAFT", "PENDING_UPLOAD", "UPLOADING"] } };

class PagingImagesFeed extends PagingFeed {
    _getFeed() {
        if (this._feedKey === "allImages_feed") {
            return this._getImagesFeed(this._EntityDef, query, {}, {});
        } else {
            return this._EntityDef.startRelatedOsImagesFeed(query, {}, {}, false);
        }
    }
    _feedReestablish() {
        return this._feed.reestablishFeed(this._activeOrgId, query, this._entityFields, this._sort);
    }

    _getImagesFeed(entityDef, filter, entityFields, sort) {
        return entityDef.startOsImageFeed(this._activeOrgId, filter, entityFields, sort, false);
    }
}

module.exports = PagingImagesFeed;
